<nz-modal [(nzVisible)]="visible" [nzTitle]="isNew ? 'New BIR Entry' : 'BIR Entry'" (nzOnCancel)="visible = false"
  (nzOnOk)="handleOk()">
  <ng-container *nzModalContent>
    <form nz-form se-container="2" [formGroup]="form" nzLayout="vertical" labelWidth="150">
      <se label="BIR Info #" required [error]="'Code is required.'" col="2">
        <input nz-input formControlName="code" maxlength="20" />
      </se>
      <se label="TIN" required [error]="'TIN and Branch Code is required.'">
        <app-view-item *ngIf="this.isNew === false"
          text="{{ form.value.tinNumber }} ({{ form.value.tinBranchCode }})"></app-view-item>
        <nz-input-group *ngIf="this.isNew === true" nzCompact class="d-flex">
          <app-tin-input formControlName="tinNumber"></app-tin-input>
          <app-tin-branch-input formControlName="tinBranchCode"></app-tin-branch-input>
        </nz-input-group>
        <span *ngIf="this.isNew === true && (form.get('tinNumber')?.hasError('required') || form.get('tinBranchCode')?.hasError('required'))" style="color: red">
          TIN and Branch Code is required.
        </span>
      </se>
      <se label="Taxpayer Type">
        <nz-select formControlName="taxpayerType">
          <nz-option [nzLabel]="'NA'" [nzValue]=0></nz-option>
          <nz-option [nzLabel]="'VAT Registered'" [nzValue]=1></nz-option>
          <nz-option [nzLabel]="'Non-VAT Registered'" [nzValue]=2></nz-option>
        </nz-select>
      </se>

      <se>
        <nz-row class="width-100" nzGutter="16">
          <nz-col nzSpan="12">
            <se label="Supplier">
              <nz-switch formControlName="isAP" [nzDisabled]="forceAP"></nz-switch>
            </se>
          </nz-col>
          <nz-col nzSpan="12">
            <se label="Customer">
              <nz-switch formControlName="isAR" [nzDisabled]="forceAR"></nz-switch>
            </se>
          </nz-col>
        </nz-row>
      </se>
      <se>
        <nz-row class="width-100" nzGutter="16">
          <nz-col nzSpan="12">
            <se label="Category">
              <nz-select formControlName="waCategory">
                <nz-option nzLabel="Private" [nzValue]="1"></nz-option>
                <nz-option nzLabel="Government" [nzValue]="2"></nz-option>
              </nz-select>
            </se>
          </nz-col>
          <nz-col nzSpan="12">
            <se label="Classification">
              <nz-select formControlName="classification">
                <nz-option nzLabel="Non-Individual" [nzValue]="1"></nz-option>
                <nz-option nzLabel="Individual" [nzValue]="2"></nz-option>
              </nz-select>
            </se>
          </nz-col>
        </nz-row>

      </se>
      <se label="Company Name" col="2" *ngIf="form.value.classification === 1">
        <input nz-input formControlName="companyName" maxlength="100" />
      </se>
      <ng-container *ngIf="form.value.classification === 2">
        <nz-row class="width-100" nzGutter="16">
          <nz-col nzSpan="12">
            <se label="Last Name" col="1">
              <input nz-input formControlName="lastName" maxlength="30" />
            </se>
          </nz-col>
          <nz-col nzSpan="12">
            <se label="First Name" col="1">
              <input nz-input formControlName="firstName" maxlength="30" />
            </se>
          </nz-col>
          <nz-col nzSpan="12">
            <se label="Middle Name" col="1">
              <input nz-input formControlName="middleName" maxlength="30" />
            </se>
          </nz-col>
        </nz-row>
      </ng-container>
      <se *ngIf="isGlVoucher">
        <nz-row class="width-100" nzGutter="16">
          <nz-col nzSpan="24">
            <se label="Sub street, Street, Barangay">
              <input nz-input formControlName="address" maxlength="30" />
            </se>
          </nz-col>
          <nz-col nzSpan="24">
            <se label="District, City">
              <input nz-input formControlName="district" maxlength="30" />
            </se>
          </nz-col>
          <nz-col nzSpan="8">
            <se label="ZipCode">
              <input nz-input formControlName="zipCode" maxlength="30" />
            </se>
          </nz-col>
        </nz-row>
      </se>
    </form>
  </ng-container>
</nz-modal>